<template>
  <div class="tiktok">
    <el-table class="tiktok_list" :data="list">
      <el-table-column type="index" label="排名" width="60" align="center">
      </el-table-column>
      <el-table-column prop="head" label="头像" width="80" align="center">
        <template slot-scope="scope">
          <el-image
            style="width: 44px; height: 44px"
            :src="scope.row.head"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="昵称" align="center">
      </el-table-column>
      <el-table-column prop="teamName" label="团队名称" align="center">
      </el-table-column>
      <el-table-column prop="sex" label="性别" width="80" align="center">
        <template slot-scope="{ row }">
          {{ row.sex == "M" ? "男" : "女" }}
        </template>
      </el-table-column>
      <el-table-column prop="city" label="城市" align="center">
      </el-table-column>
      <el-table-column prop="fan" label="粉丝量" align="center">
      </el-table-column>
      <el-table-column prop="follow" label="关注量" align="center">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { kuaishouList } from "@/api/team";
export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$loading.show();
      kuaishouList({ classId: this.$route.query.id }).then(
        ({ code, data, msg }) => {
          this.$loading.hide();
          if (code == 0) {
            this.list = data;
          } else {
            this.$message.error(msg);
          }
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
.tiktok {
  background-color: rgb(255, 255, 255);

  .top_row {
    margin-bottom: 10px;
    line-height: 32px;
    overflow: hidden;

    .title {
      float: left;
    }

    .btn {
      float: right;
    }
  }

  ::v-deep(.tiktok_list) {
    .is-leaf {
      color: #fff;
      background-color: #f56c6c;
    }

    .rank_num {
      display: inline-block;
      width: 22px;
      height: 22px;
      background: #f0f2f5;
      border-radius: 50%;
    }
  }
}
</style>
